import { ThrowableStatus } from "@wss/error-tracking/throwable";

const fetchSendProductPriceDiscountTextMessage = async (
  phoneNumber: string,
  itemNumber: string
): Promise<ThrowableStatus<Response>> => {
  try {
    const sanitizedPhoneNumber = phoneNumber.replace(/\D/g, "");

    const response = await fetch(
      "/product-promotion/send-product-price-discount-text-message",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phoneNumber: sanitizedPhoneNumber, itemNumber }),
      }
    );

    return response.ok
      ? { isError: false, value: response }
      : {
          isError: true,
          status: response.status,
          error: new Error(response.statusText),
        };
  } catch (error) {
    return {
      isError: true,
      status: null,
      error: new Error(
        "Error occurred with the '/product-promotion/send-product-price-discount-text-message' endpoint.",
        {
          cause: error,
        }
      ),
    };
  }
};

export default fetchSendProductPriceDiscountTextMessage;
